import { render, staticRenderFns } from "./UserPermissionEdit.vue?vue&type=template&id=9b25790a"
import script from "./UserPermissionEdit.vue?vue&type=script&lang=js"
export * from "./UserPermissionEdit.vue?vue&type=script&lang=js"
import style0 from "./UserPermissionEdit.vue?vue&type=style&index=0&id=9b25790a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports